// Keys are the free-string breadcrumb labels declared in each route's
// `staticData` (e.g. `breadCrumb: 'Vehicles'`); `AppBreadcrumbs` translates
// with a fallback to the raw string, so an unmapped label still renders.
export const breadcrumbs = {
  'Fleet Management': 'Fleet Management',
  Vehicles: 'Vehicles',
  'Vehicle Detail': 'Vehicle Detail',
  'Add Vehicle': 'Add Vehicle',
  Drivers: 'Drivers',
  'Driver Detail': 'Driver Detail',
  'Add Driver': 'Add Driver',
  'Data Sharing': 'Data Sharing',
  Developer: 'Developer',
  Demo: 'Demo',
  User: 'User',
  Account: 'Account',
  Billing: 'Billing',
  Notifications: 'Notifications',
  Logout: 'Logout',
  Login: 'Login',
  Users: 'Users',
  'User Detail': 'User Detail',
  'Org Units': 'Org Units',
  Locations: 'Locations',
  Contracts: 'Contracts',
  'Contract Detail': 'Contract Detail',
  'Add Contract': 'Add Contract',
};

export type BreadcrumbsResources = typeof breadcrumbs;
export type BreadcrumbKey = keyof typeof breadcrumbs;
